import React, { memo, useRef } from 'react';
import AIAgentCenterHistorySessionsFilter from './AIAgentCenterHistorySessionsFilter';
import { useAIAgentCenterContext } from 'contexts/ai-agent-center';
import AICallHistoryList, { AICallHistoryListRefProps } from './AICallHistoryList';
import AIChatHistoryList, { AIChatHistoryListRefProps } from './AIChatHistoryList';

const AIAgentCenterHistorySessions: React.FC = () => {
  const { type } = useAIAgentCenterContext();
  const listChatRef = useRef<AIChatHistoryListRefProps>(null);
  const listCallRef = useRef<AICallHistoryListRefProps>(null);

  const handleSearchCall = () => {
    listCallRef.current?.handleRefetchCallHistory();
  };

  const handleSearchChat = () => {
    listChatRef.current?.handleRefetchChatHistory();
  };

  return (
    <div className='flex h-[calc(100vh-178px)] flex-col'>
      <div>
        <AIAgentCenterHistorySessionsFilter onSearchChat={handleSearchChat} onSearchCall={handleSearchCall} />
      </div>
      <div className='flex min-h-0 flex-1'>
        {type === 'phone' ? <AICallHistoryList ref={listCallRef} /> : <AIChatHistoryList ref={listChatRef} />}
      </div>
    </div>
  );
};

export default memo(AIAgentCenterHistorySessions);
